import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import restaurantIcon from "../../../../assets/images/icons/catering-icons/restaurantIconBlue.svg";
import formatNumberWithCommas from "../../../../core/utils/formatNumberWithCommas";

function OrdersOverview({ recentOrderData }) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Orders overview
        </MDTypography>
        <MDBox mt={0} mb={2}>
          <MDTypography variant="button" color="text" fontWeight="regular">
            Recent orders
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox p={2}>
        {recentOrderData &&
          recentOrderData.map((item, index) => {
            return (
              <TimelineItem
                key={index}
                icon={restaurantIcon}
                title={item?._account_from_accounts?.restaurant_store.name}
                dateTime={
                  item?._linkedOrder_restaurant_store_orders?.deliveryDate &&
                  new Date(item?._linkedOrder_restaurant_store_orders?.deliveryDate).toDateString()
                }
                orderPoint={item.points ? `${item.points}` : "0"}
                campaignPoint={item?.campaignPoints && `${item.campaignPoints}`}
                nsuPoints={item?.nsuPoints && `${item.nsuPoints}`}
                rewardPoints={item?.rewardPoints && `${item.rewardPoints}`}
                orderAmount={`$${formatNumberWithCommas(item.amountInCents / 100)} `}
                lastItem={recentOrderData.length - 1 === index ? true : false}
                isIconRequired={true}
                campaignName={item?.campaignName && item?.campaignName}
              />
            );
          })}
      </MDBox>
      <Divider />
      <MDBox p={2} sx={{ display: "flex", justifyContent: "end" }}>
        <Link to="/order-history">
          <MDTypography
            variant="button"
            fontWeight="medium"
            color="info"
            style={true ? { textDecoration: "underline", cursor: "pointer" } : {}}
          >
            {"View all orders "}
          </MDTypography>
        </Link>
      </MDBox>
    </Card>
  );
}

OrdersOverview.propTypes = {
  recentOrderData: PropTypes.any,
};
export default OrdersOverview;
